<form [formGroup]="filterForm" id="formFilter" (ngSubmit)="onSubmit()">
  <mat-list-item  *ngFor="let item of filter.options; let i = index">
    <mat-checkbox cdkFocusInitial color="accent" [checked]="selection.includes(item)" (change)="onChange(item, $event.checked)">
      {{item.label | translate}}
    </mat-checkbox>
  </mat-list-item>
</form>
